import { render, staticRenderFns } from "./CompanyInfoForm.vue?vue&type=template&id=6bb7be2c&scoped=true&"
import script from "./CompanyInfoForm.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoForm.vue?vue&type=style&index=0&id=6bb7be2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7be2c",
  null
  
)

export default component.exports